// extracted by mini-css-extract-plugin
export var grid = "_1t-0";
export var span1 = "_1t-2";
export var span10 = "_1t-b";
export var span10L = "_1t-z";
export var span10M = "_1t-n";
export var span10Xl = "_1t-1b";
export var span11 = "_1t-c";
export var span11L = "_1t-10";
export var span11M = "_1t-o";
export var span11Xl = "_1t-1c";
export var span12 = "_1t-d";
export var span12L = "_1t-11";
export var span12M = "_1t-p";
export var span12Xl = "_1t-1d";
export var span1L = "_1t-q";
export var span1M = "_1t-e";
export var span1Xl = "_1t-12";
export var span2 = "_1t-3";
export var span2L = "_1t-r";
export var span2M = "_1t-f";
export var span2Xl = "_1t-13";
export var span3 = "_1t-4";
export var span3L = "_1t-s";
export var span3M = "_1t-g";
export var span3Xl = "_1t-14";
export var span4 = "_1t-5";
export var span4L = "_1t-t";
export var span4M = "_1t-h";
export var span4Xl = "_1t-15";
export var span5 = "_1t-6";
export var span5L = "_1t-u";
export var span5M = "_1t-i";
export var span5Xl = "_1t-16";
export var span6 = "_1t-7";
export var span6L = "_1t-v";
export var span6M = "_1t-j";
export var span6Xl = "_1t-17";
export var span7 = "_1t-8";
export var span7L = "_1t-w";
export var span7M = "_1t-k";
export var span7Xl = "_1t-18";
export var span8 = "_1t-9";
export var span8L = "_1t-x";
export var span8M = "_1t-l";
export var span8Xl = "_1t-19";
export var span9 = "_1t-a";
export var span9L = "_1t-y";
export var span9M = "_1t-m";
export var span9Xl = "_1t-1a";
export var stretch = "_1t-1";